
const state = {
  clothCounterLoads: [
    {
      id: 1,
      piezas: 1,
      color: "Color",
      notes: ""
    },
  ],
  pendientesDatePickerModalContext: "GLOBAL"
};

const getters = {
  cargasPorLavar: state => state.clothCounterLoads,
  datePickerModalContext: state => state.pendientesDatePickerModalContext
};

const actions = {
  changeDatePickerModalContext: ({ commit }, newContext) => {
    commit('setDatePickerModalContext', newContext);
  },
  addClothCounterLaundryLoad: ({ commit }, cargaPayload) => {
    commit('addSingleLaundryLoad', cargaPayload);
  },
  removeLaundryLoad: ({ commit }, laundryLoadID) => {
    commit('removeSingleLaundryLoad', laundryLoadID);
  },
  increaseClothesCount: ({ commit }, cargaPayload) => {
    commit('updateLaundryLoad', cargaPayload);
  },
  selectLaundryLoadColor: ({ commit }, cargaPayload) => {
    commit('setColorSelection', cargaPayload);
  },
  addLaundryLoadNotes: ({ commit }, cargaPayload) => {
    commit('setLaundryLoadNotes', cargaPayload);
  },
  resetClothCounter: ({ commit }) => {
    commit('resetClothCounterLoads');
  },
};

const mutations = {
  setDatePickerModalContext: (state, newContext) => {
    state.pendientesDatePickerModalContext = newContext;
  },
  addSingleLaundryLoad: (state, carga) => {
    carga.id = state.clothCounterLoads.length + 1;
    state.clothCounterLoads = [...state.clothCounterLoads, carga];
  },
  updateLaundryLoad: (state, carga) => {
    const foundLaundryLoad = state.clothCounterLoads.find(currCarga => (currCarga.id == carga.id));
    foundLaundryLoad.piezas = carga.piezas;
  },
  removeSingleLaundryLoad: (state, laundryLoadID) => {
    state.clothCounterLoads = state.clothCounterLoads.filter(carga => carga.id !== laundryLoadID);
  },
  setColorSelection: (state, carga) => {
    const foundLaundryLoad = state.clothCounterLoads.find(currCarga => (currCarga.id == carga.id));
    foundLaundryLoad.color = carga.color;
  },
  setLaundryLoadNotes: (state, carga) => {
    const foundLaundryLoad = state.clothCounterLoads.find(currCarga => (currCarga.id == carga.id));
    foundLaundryLoad.notes = carga.notes;
  },
  resetClothCounterLoads: (state) => {
    state.clothCounterLoads = [];
  },
};

export default {
  state,
  getters,
  actions,
  mutations
};